export default {
    namespaced: true,
    state: {
        files: []
    },
    getters: {
        getFiles: (state) => state.files,
    },
    mutations: {
        SET_FILE(state, payload) {
            state.files[payload.index] = payload.value
        },
    },
    actions: {}
}
